import React from 'react';

export default function KeyIcon({ width = 13, height = 14, fill = '#171C33' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.625 5.12496C9.62499 4.80507 9.50295 4.48518 9.25888 4.24112C9.01481 3.99704 8.6949 3.875 8.375 3.875M8.375 8.875C10.4461 8.875 12.125 7.19607 12.125 5.125C12.125 3.05393 10.4461 1.375 8.375 1.375C6.30393 1.375 4.625 3.05393 4.625 5.125C4.625 5.29605 4.63645 5.46442 4.65863 5.6294C4.69511 5.90074 4.71335 6.03641 4.70107 6.12224C4.68828 6.21166 4.672 6.25984 4.62793 6.33869C4.58562 6.41438 4.51107 6.48893 4.36196 6.63804L1.16789 9.83211C1.0598 9.9402 1.00575 9.99425 0.9671 10.0573C0.932832 10.1132 0.907579 10.1742 0.892269 10.238C0.875 10.3099 0.875 10.3863 0.875 10.5392V11.625C0.875 11.975 0.875 12.15 0.943121 12.2837C1.00304 12.4013 1.09865 12.497 1.21626 12.5569C1.34995 12.625 1.52497 12.625 1.875 12.625H3.375V11.375H4.625V10.125H5.875L6.86196 9.13804C7.01107 8.98893 7.08562 8.91438 7.16131 8.87207C7.24016 8.828 7.28834 8.81172 7.37776 8.79893C7.46359 8.78665 7.59926 8.80489 7.8706 8.84137C8.03558 8.86355 8.20395 8.875 8.375 8.875Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
